import React from 'react';
import { Tab, Header, Segment, Form, Responsive } from 'semantic-ui-react';
import axios from 'axios';
import Courses from './Courses';
import ArchivedCourses from './ArchivedCourses';
import { fetchFaculties } from '../../Lookups/util';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class CreateCoursesBasic extends React.Component {
    constructor(props) {
        super(props);
        let storedOrgUnitId = '';

        if (localStorage.getItem('orgUnitId')) {
            storedOrgUnitId = parseInt(localStorage.getItem('orgUnitId'), 10);
        }

        this.state = {
            orgUnits: [],
            orgUnitId: storedOrgUnitId,
            loaded: false
        };

        this.handleInputChange = this.handleInputChange.bind(this);
    }


    componentDidMount() {
        axios.all([fetchFaculties()])
            .then(axios.spread((orgUnitsRes) => {
                const orgUnits = orgUnitsRes.data.map(el => ({
                    ...el, key: el.id, value: el.id, text: el.name
                }));
                this.setState({ orgUnits });
            }))
            .catch(err => {
                this.setState({ error: true });
                console.log('Failed to fetch org. units');
            });

        if (localStorage.getItem('orgUnitId')) { this.setState({ loaded: true }); }
    }

    handleInputChange(event, { name, value }) {
        this.setState({
            loaded: false

        }, () => { this.setState({ [name]: value, loaded: !!value }); });

        localStorage.setItem('orgUnitId', value);
    }


    render() {
        const panes = [
            {
                menuItem: 'Aktivni predmeti',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <Courses
                        orgUnitId={this.state.orgUnitId}
                    /></Tab.Pane>)
            },
            {
                menuItem: 'Arhivirani predmeti',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <ArchivedCourses
                        orgUnitId={this.state.orgUnitId}
                    /></Tab.Pane>)
            }
        ];

        return (
            <div>
                <Header as="h1">Predmeti</Header>

                <Segment.Group raised>
                    <Segment raised>
                        <Header as="h3">
                            Odabir organizacione jedinice
                        </Header>
                    </Segment>
                    <Segment>
                        <Form>
                            <Form.Group widths="equal">
                                <Form.Field>
                                    <label>Organizaciona jedinica</label>
                                    <Form.Dropdown
                                        clearable
                                        placeholder="Odaberite organizacionu jedinicu"
                                        value={localStorage.getItem('orgUnitId') ? parseInt(localStorage.getItem('orgUnitId'), 10) : this.state.orgUnitId}
                                        onChange={this.handleInputChange}
                                        name="orgUnitId"
                                        options={this.state.orgUnits}
                                        search
                                        fluid
                                        selection
                                    />
                                </Form.Field>
                                <Form.Field/>
                                {/*<Form.Button color="blue" basic="true" label=" " onClick={() => this.setState({ loaded: true })}>Prikaži</Form.Button>*/}
                            </Form.Group>
                        </Form>
                        <br />
                    </Segment>

                    {this.state.loaded &&
                    <Segment><Tab menu={{ secondary: true, pointing: true, color: 'blue' }} panes={panes} /></Segment>
                    }
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Admin/CreateCourse/CreateCourseBasic.js